export default __webpack_public_path__ + "static/media/me.27ef1092.png";